import React from 'react';
import { APP } from '../tokens';

const F = APP.fontFamily;

type SourceType = 'drive' | 'notion' | 'slack' | 'gmail';

const SOURCE_LABELS: Record<SourceType, string> = {
  drive: 'Drive',
  notion: 'Notion',
  slack: 'Slack',
  gmail: 'Gmail',
};

function DriveChipIcon() {
  return (
    <svg width="12" height="10" viewBox="0 0 87.3 78" fill="none" style={{ flexShrink: 0 }}>
      <path d="M6.6 66.85l3.85 6.65c.8 1.4 1.95 2.5 3.3 3.3l13.75-23.8H0c0 1.55.4 3.1 1.2 4.5l5.4 9.35z" fill="#0066da" />
      <path d="M43.65 25.15L29.9 1.35c-1.35.8-2.5 1.9-3.3 3.3L1.2 52.7c-.8 1.4-1.2 2.95-1.2 4.5h27.5l16.15-32.05z" fill="#00ac47" />
      <path d="M73.55 76.8c1.35-.8 2.5-1.9 3.3-3.3l1.6-2.75 7.65-13.25c.8-1.4 1.2-2.95 1.2-4.5H59.8l-5.9 11.35-6.15 12.45h25.8z" fill="#ea4335" />
      <path d="M43.65 25.15L57.4 1.35C56.05.55 54.5 0 52.85 0H34.45c-1.65 0-3.2.55-4.55 1.35l13.75 23.8z" fill="#00832d" />
      <path d="M59.8 53H27.5L13.75 76.8c1.35.8 2.9 1.2 4.55 1.2h36.7c1.65 0 3.2-.45 4.55-1.2L59.8 53z" fill="#2684fc" />
      <path d="M73.4 26.5l-12.7-22c-.8-1.4-1.95-2.5-3.3-3.3L43.65 25.15 59.8 53h27.5c0-1.55-.4-3.1-1.2-4.5L73.4 26.5z" fill="#ffba00" />
    </svg>
  );
}

function NotionChipIcon() {
  return (
    <svg width="12" height="12" viewBox="0 0 100 100" fill="none" style={{ flexShrink: 0 }}>
      <path d="M6.017 4.313l55.333-4.087c6.797-.583 8.543-.19 12.817 2.917l17.663 12.443c2.913 2.14 3.883 2.723 3.883 5.053v68.243c0 4.277-1.553 6.807-6.99 7.193L24.467 99.967c-4.08.193-6.023-.39-8.16-3.113L3.3 79.94c-2.333-3.113-3.3-5.443-3.3-8.167V11.113c0-3.497 1.553-6.413 6.017-6.8z" fill="#000" />
      <path d="M25.723 19.01c-5.25.387-6.45.467-9.46-1.943l-7.2-5.637c-.78-.777-.39-1.75 1.36-1.943l51.06-3.693c4.277-.39 6.413 1.163 8.16 2.527l8.737 6.223c.39.193 1.36 1.36.193 1.36l-52.85 3.107z" fill="#fff" />
      <path d="M19.513 88.303V25.03c0-2.723.967-3.89 3.497-4.08l58.05-3.5c2.333-.193 3.497 1.167 3.497 3.89v62.883c0 2.723-.387 5.053-3.883 5.247L24.56 92.58c-3.5.193-5.047-.97-5.047-4.277z" fill="#fff" />
      <path d="M71.43 42.6c.58 2.53 0 5.05-2.53 5.44l-2.72.58v44.89c-2.33 1.17-4.47 1.75-6.22 1.75-2.92 0-3.69-.78-5.83-3.5L36.27 64.04v26.75l5.64 1.36s0 3.3-4.67 3.3l-12.82.78c-.39-.78 0-2.72 1.36-3.11l3.5-.97V37.1l-4.86-.39c-.58-2.53.97-6.22 5.44-6.61l13.79-.97 18.14 27.73V30.52l-4.67-.58c-.58-2.92 1.55-5.05 4.28-5.25l12.48-.78z" fill="#000" />
    </svg>
  );
}

function SlackChipIcon() {
  return (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" style={{ flexShrink: 0 }}>
      <path d="M5.042 15.165a2.528 2.528 0 0 1-2.52 2.523A2.528 2.528 0 0 1 0 15.165a2.527 2.527 0 0 1 2.522-2.52h2.52v2.52z" fill="#E01E5A" />
      <path d="M6.313 15.165a2.527 2.527 0 0 1 2.521-2.52 2.527 2.527 0 0 1 2.521 2.52v6.313A2.528 2.528 0 0 1 8.834 24a2.528 2.528 0 0 1-2.521-2.522v-6.313z" fill="#E01E5A" />
      <path d="M8.834 5.042a2.528 2.528 0 0 1-2.521-2.52A2.528 2.528 0 0 1 8.834 0a2.528 2.528 0 0 1 2.521 2.522v2.52H8.834z" fill="#36C5F0" />
      <path d="M8.834 6.313a2.528 2.528 0 0 1 2.521 2.521 2.528 2.528 0 0 1-2.521 2.521H2.522A2.528 2.528 0 0 1 0 8.834a2.528 2.528 0 0 1 2.522-2.521h6.312z" fill="#36C5F0" />
      <path d="M18.956 8.834a2.528 2.528 0 0 1 2.522-2.521A2.528 2.528 0 0 1 24 8.834a2.528 2.528 0 0 1-2.522 2.521h-2.522V8.834z" fill="#2EB67D" />
      <path d="M17.688 8.834a2.528 2.528 0 0 1-2.523 2.521 2.527 2.527 0 0 1-2.52-2.521V2.522A2.527 2.527 0 0 1 15.165 0a2.528 2.528 0 0 1 2.523 2.522v6.312z" fill="#2EB67D" />
      <path d="M15.165 18.956a2.528 2.528 0 0 1 2.523 2.522A2.528 2.528 0 0 1 15.165 24a2.527 2.527 0 0 1-2.52-2.522v-2.522h2.52z" fill="#ECB22E" />
      <path d="M15.165 17.688a2.527 2.527 0 0 1-2.52-2.523 2.526 2.526 0 0 1 2.52-2.52h6.313A2.527 2.527 0 0 1 24 15.165a2.528 2.528 0 0 1-2.522 2.523h-6.313z" fill="#ECB22E" />
    </svg>
  );
}

function GmailChipIcon() {
  return (
    <svg width="12" height="9" viewBox="49 42 94 74" fill="none" style={{ flexShrink: 0 }}>
      <path d="M58 108h14V74L52 59v43c0 3.32 2.69 6 6 6" fill="#4285f4" />
      <path d="M120 108h14c3.32 0 6-2.69 6-6V59l-20 15" fill="#34a853" />
      <path d="M120 48v26l20-15v-8c0-7.42-8.47-11.65-14.4-7.2" fill="#fbbc04" />
      <path d="M72 74V48l24 18 24-18v26L96 92" fill="#ea4335" />
      <path d="M52 51v8l20 15V48l-5.6-4.2c-5.94-4.45-14.4-.22-14.4 7.2" fill="#c5221f" />
    </svg>
  );
}

const ICON_MAP: Record<SourceType, React.FC> = {
  drive: DriveChipIcon,
  notion: NotionChipIcon,
  slack: SlackChipIcon,
  gmail: GmailChipIcon,
};

interface CoTSourceChipProps {
  source: SourceType;
}

export default function CoTSourceChip({ source }: CoTSourceChipProps) {
  const Icon = ICON_MAP[source];
  const label = SOURCE_LABELS[source];

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        borderRadius: 12,
        paddingBlock: 3,
        paddingInline: 8,
        gap: 5,
        backgroundColor: APP.bgSidebar,
      }}
    >
      <Icon />
      <span
        style={{
          fontSize: 11,
          fontWeight: 400,
          color: APP.textDescription,
          lineHeight: '14px',
          fontFamily: F,
        }}
      >
        {label}
      </span>
    </div>
  );
}
